import React from 'react';
import { TableCell } from '@mui/material';
import { formatCurrency } from '../../utils/formatNumber';

export default class GridBalanceCell extends React.Component {
    render() {
        const { value, field } = this.props;
        const balances = value || {};
        const baseStyle = this.props.styles;
        return (
            <TableCell key={field?.id} align="right" sx={{ ...baseStyle }}>
                {Object.entries(balances)
                    .filter(([_, amount]) => amount !== 0)
                    .map(([currency, amount]) => `${currency}: ${formatCurrency(amount)}`)
                    .join(', ') || '0'}
            </TableCell>
        );
    }
}
